"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const WorkflowConditionalIcon_1 = __importDefault(require("./WorkflowConditionalIcon"));
const WorkflowRepeatIconButton_1 = __importDefault(require("./WorkflowRepeatIconButton"));
const FormRendererHelpers_1 = require("../../utils/FormRendererHelpers");
const WorkflowFieldWrapper = (props) => {
    const { children, controlDefinition, onAddClick, onRemoveClick, repeatable, index } = props;
    const isConditionalGroup = (0, FormRendererHelpers_1.isComponentConditional)(controlDefinition);
    const handleAddClick = () => {
        onAddClick && onAddClick();
    };
    const handleRemoveClick = () => {
        onRemoveClick && onRemoveClick();
    };
    return (react_1.default.createElement("div", { style: {
            marginTop: '5px',
            marginBottom: '20px',
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
        } },
        react_1.default.createElement("div", { style: {
                flex: 1,
            } }, children),
        (isConditionalGroup || repeatable) && (react_1.default.createElement("div", { style: {
                display: 'flex',
                marginLeft: '20px',
                alignItems: 'center',
            } },
            isConditionalGroup && (!repeatable || !index) && react_1.default.createElement(WorkflowConditionalIcon_1.default, null),
            isConditionalGroup && repeatable && react_1.default.createElement("div", { style: { marginLeft: 7 } }),
            repeatable && (react_1.default.createElement(WorkflowRepeatIconButton_1.default, { onRemoveRepeatClick: handleRemoveClick, onAddRepeatClick: handleAddClick, index: index || 0 }))))));
};
exports.default = WorkflowFieldWrapper;
//# sourceMappingURL=WorkflowFieldWrapper.js.map